import { Button } from "antd";
import PropTypes from "prop-types";

import ButtonLink from "@/modules/button-link";
import { useModelLinkInline } from "@/modules/model-link";
import { usePageModalLocationState } from "@/modules/page-modal";
import { Tooltip } from "@/ui/tooltip";

import { PageModalNavigationItemType } from "./PageModalNavigationItem.type";

const PageModalNavigationItem = ({ icon, model, item, formatTitle }) => {
  const { backgroundList, backgroundLocation } = usePageModalLocationState();
  const modelLink = useModelLinkInline(model, item);
  const uiProps = { shape: "circle", icon };

  if (!item) return <Button {...uiProps} disabled />;

  return (
    <Tooltip title={formatTitle ? formatTitle(item) : item.name}>
      <ButtonLink
        {...uiProps}
        inModal
        to={modelLink}
        modalState={{
          backgroundList, // keep the list context for the previous/next items
          backgroundLocation, // force go back to original backgroundLocation on modal closed
        }}
      />
    </Tooltip>
  );
};

PageModalNavigationItem.propTypes = {
  icon: PropTypes.node.isRequired,
  model: PropTypes.string.isRequired,
  item: PageModalNavigationItemType,
  formatTitle: PropTypes.func,
};

export default PageModalNavigationItem;
